import { css } from '@emotion/react'

export interface AnimationOptions {
  delayMs?: number
  durationMs: number
  direction?: string
  fillMode?: string
  iterationCount?: number | 'infinite'
  playState?: string
  timingFn?: string
}

export const animationDefaults: Partial<AnimationOptions> = {
  delayMs: 0,
  direction: 'normal',
  fillMode: 'none',
  iterationCount: 1,
  playState: 'running',
  timingFn: 'linear',
}

export const animation =
  (animationName: string) => (options: AnimationOptions) => {
    const {
      durationMs,
      timingFn = 'linear',
      delayMs = 0,
      direction = 'normal',
      fillMode = 'none',
      iterationCount = 1,
      playState = 'running',
    } = options

    return css`
      animation: ${durationMs}ms ${timingFn} ${animationName} ${delayMs}ms
        ${direction} ${fillMode} ${iterationCount} ${playState};
    `
  }
